module.exports = __webpack_public_path__ + "static/media/options.83e87640.svg";